import Model from 'flarum/common/Model';
import mixin from 'flarum/common/utils/mixin';

export default class SupportTicketAssignee extends mixin(Model, {
  user: Model.hasOne('user'),
  ticket: Model.hasOne('ticket'),
  assignedBy: Model.hasOne('assignedBy'),
  assignedAt: Model.attribute('assignedAt'),
}) {
  apiEndpoint() {
    return '/support/tickets/assignees' + (this.exists ? '/' + this.data.id : '');
  }
}
